import { getLabelName, getLabelTooltip } from '@apia/util';
import { Switchbox, TSwitchbox } from '../../components';
import { ValidatedCollectorField } from '../ValidatedCollectorField';

export class CollectorSwitch extends ValidatedCollectorField<
  boolean,
  Omit<TSwitchbox, 'name'>
> {
  type = 'switch';

  Component = () => {
    const rules = this.useValidationRules();
    const validationFunction = this.useValidationFunction();
    const props = this.useProperties();

    return (
      <Switchbox
        {...props}
        initialValue={this.config.initialValue}
        validationFunction={validationFunction}
        name={this.name}
        label={getLabelName(this.label)}
        title={getLabelTooltip(this.label)}
        validationRules={rules}
        avoidSemicolon
        removeOnUnmount={false}
        avoidRegisterIfExists
      />
    );
  };
}
